<template>
  <div class="page-index">
    <div class="hd">
      <div class="info">
        <div class="info-hd">付款给</div>
        <!-- <div class="info-bd">镇雄视康眼科医院</div> -->
        <div class="info-bd">{{ this.GLOBAL.hosName }}</div>
      </div>
      <div class="info-icon">
        <img class="info-icon-img" src="../../assets/info-icon.png" alt="" />
      </div>
      <div class="bg"></div>
    </div>
    <div class="bd">
      <div class="box">
        <div class="box-hd">
          <div class="box-hd-label">费用总额</div>
          <div class="box-hd-value">{{ PrePayInfo.feeSumamt }}元</div>
        </div>
        <div class="box-bd">
          <div class="box-item">
            <div class="box-bd-label">医保基金支付</div>
            <div class="box-bd-value">{{ PrePayInfo.fundPay }}元</div>
          </div>
          <div class="box-item">
            <div class="box-bd-label">个人帐户支付</div>
            <div class="box-bd-value">{{ PrePayInfo.psnAcctPay }}元</div>
          </div>
          <!-- <div class="box-item">
            <div class="box-bd-label">其他抵扣金额</div>
            <div class="box-bd-value">{{ PrePayInfo.deposit }}元</div>
          </div> -->
        </div>
        <div class="box-ft">
          <div class="box-ft-label">现金支付</div>
          <div class="box-ft-value">{{ PrePayInfo.ownPayAmt }}元</div>
        </div>
        <div class="box-append" @click="handleActionsheet">查看明细</div>
      </div>
      <div class="bd-append">
        <i class="bd-append-icon"></i>
        <div class="bd-append-text">医保移动支付</div>
      </div>
    </div>
    <div class="ft">
      <div class="pay">
        <div class="pay-label">您还需支付：</div>
        <div class="pay-value">{{ PrePayInfo.feeSumamt }}元</div>
      </div>
      <div class="btn" @click="feePay" id="divBtn">去支付</div>
    </div>
    <div class="actionsheet" v-show="actionsheetVisible">
      <div class="actionsheet-mask" @click="handleActionsheet"></div>
      <div class="actionsheet-panel">
        <div class="actionsheet-hd">
          <div class="actionsheet-hd-tt">处方明细</div>
          <i class="actionsheet-icon-close" @click="handleActionsheet"></i>
        </div>
        <div class="actionsheet-bd">
          <div
            class="actionsheet-box"
            v-for="item in prescriptionList"
            :key="item.title"
          >
            <div class="actionsheet-box-hd">{{ item.title }}</div>
            <div class="actionsheet-box-bd">
              <div
                class="actionsheet-box-item"
                v-for="boxItem in item.list"
                :key="boxItem.label"
              >
                <div class="actionsheet-box-item-label-wrap">
                  <div class="actionsheet-box-item-label">
                    {{ boxItem.label }}
                  </div>
                  <div class="actionsheet-box-item-sublabel">
                    {{ boxItem.subLabel }}
                  </div>
                </div>
                <div
                  class="actionsheet-box-item-value"
                  :class="[boxItem.highlight ? 'em' : '']"
                >
                  {{ boxItem.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requests from "../../api/requests.js";
import { ref } from "vue";
import { Form, Field, CellGroup, Button, Dialog, Toast } from "vant";

export default {
  name: "PageIndex",
  data() {
    return {
      prescriptionList: [
        {
          title: "就诊信息",
          list: [
            { label: "门诊类别", value: "门(急)诊" },
            { label: "门诊科室", value: "普通内科" },
            { label: "医生姓名", value: "张三" },
            { label: "处方时间", value: "2021/06/08 14:54:00" },
            { label: "费用总额", value: "368.50元", highlight: true },
          ],
        },
        {
          title: "诊断信息",
          list: [
            { label: "诊断名称", value: "外伤肿胀" },
            { label: "诊断编号", value: "E3D.25" },
          ],
        },
        // {
        //   title: '特殊信息',
        //   list: [
        //     { label: '病情名称', value: '高血压' },
        //     { label: '病情编号', value: '2220003495858' },
        //   ]
        // },
        {
          title: "费用信息",
          list: [
            { label: "万通胫骨贴*1", subLabel: "8g/片/3", value: "37.80元" },
            { label: "阿莫西林*1", subLabel: "8g/片/3", value: "7.80元" },
          ],
        },
        // {
        //   title: '其他抵扣金额',
        //   list: [
        //     { label: '住院押金抵扣', value: '50元' },
        //     { label: '医院负担金额抵扣', value: '50元' },
        //   ]
        // },
      ],
      actionsheetVisible: false,
      //支付页面传入信息
      payInfo: {},
      //医保支付下单
      PrePayInfo: {
        feeSumamt: 0, //费用总额
        ownPayAmt: 0, //现金支付
        psnAcctPay: 0, //个人帐户支付
        fundPay: 0, //医保基金支付
        deposit: 0, //其他抵扣金额
        invoiceId: "", //票号
      },
      //MipUserInfo
      payAuthInfo: {
        code: -2,
        message: "",
        user_name: "",
        city_id: "",
        pay_auth_no: "",
        user_longitude_latitude: "",
      },
      openid: "",
      //支付类型
      ptype: "",
      userInfo: {},
      //医保支付下单请求结构体
      orderReqeust: {
        order_type: "DiagPay",
        openid: "",
        hosp_out_trade_no: "",
        hospital_name: "",
        total_fee: 0,
        cash_fee: 0,
        allow_fee_change: 0,
        //notify_url: "",服务端传
        body: "", //需要构造
        //return_url: "",服务端传
        pay_type: 0,
        insurance_fee: 0,
        user_card_type: 0,
        user_card_no: "",
        user_name: "",
        is_dept: "",
        serial_no: "",
        gmt_out_create: "",
        request_content: "", //实例：{"payAuthNo":"AUTH****","payOrdId":"ORD****","setlLatlnt":"118.096435,24.485407"}
      },
    };
  },
  created() {
    let that = this;
    //从支付页面传入的定义信息
    this.payInfo = JSON.parse(localStorage.getItem("order")).item;
    this.openid = localStorage.getItem(this.GLOBAL.hosUrl);
    this.ptype = this.$route.query.ptype;
    this.getUserInfoByOpenId(this.openid);
    //就诊单详情赋值展示
    if (this.payInfo != null) {
      this.prescriptionList = [];
      this.prescriptionList.push({
        title: "就诊信息",
        list: [
          { label: "门诊类别", value: this.payInfo.deptName },
          { label: "门诊科室", value: this.payInfo.deptName },
          { label: "医生姓名", value: this.payInfo.doctName },
          { label: "处方时间", value: this.payInfo.seeDate },
          {
            label: "费用总额",
            value: this.payInfo.totCost + "元",
            highlight: true,
          },
        ],
      });
      this.prescriptionList.push({
        title: "诊断信息",
        list: [
          { label: "诊断名称", value: this.payInfo.icdName },
          { label: "诊断编号", value: this.payInfo.icdCode },
        ],
      });
      this.getPayDetail(this.openid, this.payInfo.cardNo);
    }

    Toast.loading({
      duration: 0,
      forbidClick: true,
      overlay: true,
      message: "加载中...",
    });
    //医保支付
    //不管是医保支付还是微信支付，展示只影响支付总额，不影响上面赋值的明细
    let ptype = this.$route.query.ptype;
    localStorage.setItem(that.GLOBAL.hosUrl + "-ptype", ptype);

    if (ptype && ptype == "wx") {
      that.selfPrepay(this.openid, this.payInfo.cardNo);
    } else {
      //授权回调时 将授权信息部分展示到页面
      //医保支付完成后需要自费的金额等
      let authCode = this.$route.query.authCode;
      // 0	成功
      // 150402	用户未激活电子凭证
      // 150403	用户未授权获取payAuthNo
      let retCode = this.$route.query.retCode;
      if (retCode == 0) {
        if (authCode != "" && authCode != null) {
          that.mipuserQuery(this.openid, authCode);
        }
      } else {
        that.$router.push("/payFee");
        Toast.clear();
      }
      //这一段测试prepay 用完就删除，不影响其他代码
      // that.PrePay(this.openid, "MZ0000288073", "", "");
    }
  },
  methods: {
    //从建档数据里取的
    getUserInfoByOpenId(id) {
      const that = this;
      let httpURL = "/His/QueryRecord?openid=" + id;
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          that.userInfo = res.data;
        }
      });
    },
    handleActionsheet() {
      this.actionsheetVisible = !this.actionsheetVisible;
    },
    //费用明细
    getPayDetail(openid, cardNo) {
      const that = this;
      let httpURL =
        "/His/QueryFeedetail?openid=" + openid + "&cardNo=" + cardNo;
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null) {
          const detailList = [];
          res.data.forEach((element) => {
            detailList.push({
              label: element.itemName + "*" + element.itemNum,
              subLabel: element.itemSpec,
              value: element.totCost + "元",
            });
          });

          that.prescriptionList.push({
            title: "费用信息",
            list: detailList,
          });

          console.log(that.prescriptionList);
        } else {
          Dialog.alert({
            title: "消息提示",
            message: res.message,
          });
        }
      });
    },
    //医保下单
    PrePay(openid, cardNo, payAuthNo, uldLatlnt) {
      const that = this;
      let httpURL =
        "/His/PrePay?openId=" +
        openid +
        "&cardNo=" +
        cardNo +
        "&payAuthNo=" +
        payAuthNo +
        "&uldLatlnt=" +
        uldLatlnt;
      requests
        .get(httpURL)
        .then(function (res) {
          Toast.clear();

          if (res.data != null) {
            that.PrePayInfo = res.data;
          } else if (res.code == "-1") {
            document.getElementById("divBtn").style.color = "darkgray";
            document.getElementById("divBtn").style.pointerEvents = "none";

            Dialog.alert({
              title: "消息提示",
              message: res.message,
            });
          }
        })
        .finally((res) => {
          Toast.clear();
        });
    },

    // 从医保授权里拿的
    mipuserQuery(id, qrcode) {
      const that = this;
      let httpURL = "/wx/MipuserQuery?openid=" + id + "&qrcode=" + qrcode;
      requests.get(httpURL).then(function (res) {
        console.log(res);
        if (res.data != null && res.code == "0") {
          that.payAuthInfo = res.data;
          // that.userInfo.name = that.payAuthInfo.user_name;
          that.payAuthInfo.openid = id;
          //拿到pay auth no 后向医保支付下单
          that.PrePay(
            id,
            that.payInfo.cardNo,
            res.data.pay_auth_no,
            JSON.stringify(res.data.user_longitude_latitude)
          );
        } else {
          Toast.clear();
          Dialog.alert({
            title: "消息提示",
            message: res.message,
          });
        }
      });
    },

    //自费支付下单
    selfPrepay(openid, cardNo) {
      const that = this;
      let httpURL = "/His/SelfPrepay?openid=" + openid + "&cardNo=" + cardNo;
      requests
        .get(httpURL)
        .then(function (res) {
          // alert(JSON.stringify(res.data));

          if (res.data != null) {
            that.PrePayInfo = res.data;
            that.PrePayInfo.feeSumamt = res.data.totCost;
            that.PrePayInfo.fundPay = 0;
            that.PrePayInfo.psnAcctPay = 0;
            that.PrePayInfo.ownPayAmt = res.data.totCost;
          } else if (res.code == "-1") {
            document.getElementById("divBtn").style.color = "darkgray";
            document.getElementById("divBtn").style.pointerEvents = "none";

            Dialog.alert({
              title: "消息提示",
              message: res.message,
            });
          }
          Toast.clear();
        })
        .finally((res) => {
          Toast.clear();
        });
    },

    //去支付
    feePay() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        overlay: true,
        message: "加载中...",
      });
      const that = this;
      that.orderReqeust.order_type = "DiagPay";
      that.orderReqeust.openid = that.openid;
      that.orderReqeust.hospital_name = that.GLOBAL.hosName;
      that.orderReqeust.allow_fee_change = 1;

      if (that.PrePayInfo && that.PrePayInfo.extData != null) {
        that.orderReqeust.hosp_out_trade_no =
          that.PrePayInfo.extData.hospOutTradeNo;
        that.orderReqeust.total_fee = parseFloat(
          that.PrePayInfo.extData.totalFee
        );
        that.orderReqeust.cash_fee = parseFloat(
          that.PrePayInfo.extData.cashFee
        );
        that.orderReqeust.body = that.PrePayInfo.extData.body;
        //1：现金 2：医保 3：现金+医保
        // 备注说明：
        // 1、当订单要走医保支付时，
        // （1）cash_fee>0, paytype填3
        // （2）cash_fee=0, paytype填2
        // 2、当订单不使用医保支付时 paytype填1
        if (that.ptype == "wx") {
          that.orderReqeust.pay_type = 1;
        } else {
          if (that.orderReqeust.cash_fee > 0) {
            that.orderReqeust.pay_type = 3;

            //现金金额大于0，医保金额和自费金额都为0，走现金支付
            if (that.PrePayInfo.ownPayAmt > 0 && that.PrePayInfo.psnAcctPay == 0 && that.PrePayInfo.fundPay == 0) {
              that.orderReqeust.pay_type = 1;
            }
           
           
          } else if (that.orderReqeust.cash_fee == 0) {
            that.orderReqeust.pay_type = 2;
          }
        }
        that.orderReqeust.insurance_fee = parseFloat(
          that.PrePayInfo.extData.insuranceFee
        );
        that.orderReqeust.user_card_type = that.PrePayInfo.extData.userCardType;
        that.orderReqeust.user_card_no = that.userInfo.idenno;
        that.orderReqeust.user_name = that.userInfo.name;
        that.orderReqeust.is_dept = that.PrePayInfo.extData.isDept;
        that.orderReqeust.serial_no = that.PrePayInfo.extData.serialNo;
        that.orderReqeust.gmt_out_create = that.PrePayInfo.extData.gmtOutCreate;
        ///实例：{"payAuthNo":"AUTH****","payOrdId":"ORD****","setlLatlnt":"118.096435,24.485407"}
        that.orderReqeust.request_content =
          that.PrePayInfo.extData.requestContent;
      }
      let httpURL = "/PayInsurance/unifiedorder?openid=" + that.openid;
      requests
        .post(httpURL, JSON.stringify(that.orderReqeust))
        .then(function (res) {
          Toast.clear();
          if (res.data != null) {
            //alert(JSON.stringify(res.data));

            if (
              res.data.return_code == "SUCCESS" &&
              res.data.result_code != "SUCCESS"
            ) {
              Dialog.alert({
                title: "消息提示",
                message: "[" + res.data.err_code + "]" + res.data.err_code_des,
              });
              return;
            }

            if (
              res.data.return_code == "SUCCESS" &&
              res.data.result_code == "SUCCESS"
            ) {
              if (that.PrePayInfo && that.PrePayInfo.extData != null) {
                // queryPay(
                //   that.PrePayInfo.payOrdId,
                //   that.openid,
                //   res.data.med_trans_id,
                //   that.PrePayInfo.hospOutTradeNo,
                //   that.PrePayInfo.extData.serialNo
                // );
                //在微信跳转到payResult时获取支付结果使用下面的参数
                localStorage.setItem(
                  that.GLOBAL.hosUrl + "-payOrdId",
                  that.PrePayInfo.payOrdId
                );
                localStorage.setItem(
                  that.GLOBAL.hosUrl + "-med_trans_id",
                  res.data.med_trans_id
                );
                localStorage.setItem(
                  that.GLOBAL.hosUrl + "-hospOutTradeNo",
                  that.PrePayInfo.hospOutTradeNo
                );
                localStorage.setItem(
                  that.GLOBAL.hosUrl + "-serialNo",
                  that.PrePayInfo.extData.serialNo
                );
              }
              window.location.href = res.data.pay_url;
            } else {

              Dialog.alert({
                title: "消息提示",
                message: "无效订单",
              });
              // that.$router.push({ path: "/orders" });
            }
          }
        })
        .finally((res) => {
          Toast.clear();
        });
    },
  },
};
</script>

<style scoped>
@import "./index.css";
@import "./actionsheet.css";
</style>



// WEBPACK FOOTER //
// src/views/orderDetail/index.vue